/** @jsx jsx */
import React, { Component } from 'react';
import { css, jsx } from '@emotion/core';
import styled from '@emotion/styled';
import DetailsSecuritySolutionFireEyeImg from "./DetailsSecuritySolutionFireEye.png";
import DetailsSecuritySolutionFireEyeIcon1 from "./DetailsSecuritySolutionFireEyeIcon1.png";
import DetailsSecuritySolutionFireEyeIcon2 from "./DetailsSecuritySolutionFireEyeIcon2.png";
import DetailsSecuritySolutionFireEyeIcon3 from "./DetailsSecuritySolutionFireEyeIcon3.png";
import DetailsSecuritySolutionFireEyeIcon4 from "./DetailsSecuritySolutionFireEyeIcon4.png";
import DetailsSecuritySolutionFireEyeIcon5 from "./DetailsSecuritySolutionFireEyeIcon5.png";
import DetailsSecuritySolutionFireEyeIcon6 from "./DetailsSecuritySolutionFireEyeIcon6.png";
import DetailsSecuritySolutionFireEyeIcon7 from "./DetailsSecuritySolutionFireEyeIcon7.png";
import DetailsSecuritySolutionFireEyeIcon8 from "./DetailsSecuritySolutionFireEyeIcon8.png";
import GraphicSectionMidsize from "../../Sections/GraphicSectionMidsize";

const Section = styled.section`
  border: 0px solid #dadce0;

  color: #363a3c;
  
  font-family: 'Malgun Gothic';
  font-family: 'Noto Sans KR', sans-serif;
  font-family: 'Spoqa Han Sans', 'Spoqa Han Sans JP', 'Sans-serif';
`;
const SubSection = styled.div`
  margin-bottom: 50px;
`;
const ContainerFluid = styled.div`
  margin-left: auto;
  margin-right: auto;
  padding: 16px 24px;

  box-sizing: border-box;
  max-width: 1140px;
`;
const HighlightText = styled.h1`
  margin-top: 0;
  margin-bottom: 0;
  word-break: break-all;
  font-size: 20px;
  line-height: 1.6;
  
  box-sizing: border-box;
`;
const CssHeaderText100 = css`
  font-weight: 100;
`;
const CssHeaderText300 = css`
  font-weight: 300;
`;
const CssHeaderText400 = css`
  font-weight: 400;
`;

const DivFlexboxWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;
const DivFlexItem = styled.div`
  border: 0px solid #dadce0;
  box-sizing: border-box;
  width: 360px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0px;
`;
const DivFlexboxNoWrap = styled.div`
  display: flex;
  justify-content: center;
`;
const DivFlexItemNoWrap = styled.div`
  border: 0px solid #dadce0;
  box-sizing: border-box;
  padding-top: 20px;
`;
const ImgFlexItemNoWrap = styled.img`
  width: 100%;
`;

const SpanAbsoluteBold = styled.span`
  position: absolute;
  font-weight: 700;
`;
const DivIndent20 = styled.div`
  margin-left: 20px;
`;
const DivFlexboxColumn = styled.div`
  display: flex;
  flex-direction: column;
`;
const DivFlexboxColumnFlexEnd = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;
const DivFlexboxRow = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
`;

const FireEyeIcon = styled.img`
  width: 100px;
`;

class DetailsSecuritySolutionFireEye extends Component {
  render() {
    let data = [
      {
        icon: DetailsSecuritySolutionFireEyeIcon1,
        title: "FireEye Helix",
        titleColor: "#f69b22",
        desc: "사고 경보부터 해결에 이르는 모든 과정을 제어할 수 있는 보안 운영 플랫폼입니다 . FireEye Helix 는 고객의 보안 툴을 통합하고 SIEM, 오케스트레이션 및 위협 인텔리전스 기능으로 강화하여 보안 투자를 최대한 활용할 수 있도록 합니다 .",
      },
      {
        icon: DetailsSecuritySolutionFireEyeIcon2,
        title: "FireEye Network Security 및 포렌식",
        titleColor: "#6b833b",
        desc: "세계에서 가장 지능화된 공격을 분석하여 가시성을 제공함으로써 알려진 위협과 알려지지 않은 위협으로부터 네트워크, 자산, 사용자를 안전하게 보호하는 지능형 위협 방어 및 보안 침해 탐지 솔루션입니다 .",
      },
      {
        icon: DetailsSecuritySolutionFireEyeIcon3,
        title: "FireEye Endpoint Security",
        titleColor: "#28589b",
        desc: "다양한 엔진으로 사용자를 보호하며 악성코드와 익스플로잇을 차단하고 , 지능형 공격을 탐지하며 , 세계 최고의 일선 대응 담당자들이 개발한 대응\n" +
          "툴과 기술을 제공하는 포괄적인 엔드포인트 솔루션입니다 .",
      },
      {
        icon: DetailsSecuritySolutionFireEyeIcon4,
        title: "FireEye Email Security",
        titleColor: "#b2282d",
        desc: "일선에서 얻은 공격 및 공격자에 대한 지식을 바탕으로 이메일을 통한 위협이 피해를 입히기 전에 차단하는 이메일 보호 솔루션입니다 . 이 솔루션은\n" +
          "악성코드와 수상한 URL 은 물론, 피싱 및 사칭 기법까지 차단합니다.",
      },
      {
        icon: DetailsSecuritySolutionFireEyeIcon5,
        title: "FireEye Expertise On Demand",
        titleColor: "#e85727",
        desc: "업계에서 그 우수성을 인정받은 FireEye 의 보안 전문성을 유연하게 이용하여 고객이 필요로 하는 역량을 적시에 제공하는 온디맨드\n" +
          "방식의 프리페이 연간 구독 서비스입니다 .",
      },
      {
        icon: DetailsSecuritySolutionFireEyeIcon6,
        title: "FireEye Threat Intelligence",
        titleColor: "#2a5799",
        desc: "조직이 사전 예방적인 방어 수단을 구축하고 , 경보의 우선 순위를 정하고 , 리소스를 할당하며 , 사고 대응을 개선하는 데 필요한 선제적인 상황 정보를\n" +
          "추가함으로써 단순히 보안 제품의 차단 기능을 강화하는 것 이상의 효과를 실현하는 인텔리전스 서비스 포트폴리오입니다 .",
      },
      {
        icon: DetailsSecuritySolutionFireEyeIcon7,
        title: "FireEye Managed Defense",
        titleColor: "#6b833b",
        desc: "업계에서 인정받는 사이버 보안 전문성과 FireEye 기술 , 공격자에 대한 독보적인 지식을 결합하여 공격 주기의 조기에 위협을 식별하고 보안 침해의\n" +
          "잠재적 영향을 최소화하도록 지원하는 관리형 탐지 및 대응 (MDR) 서비스입니다 .",
      },
      {
        icon: DetailsSecuritySolutionFireEyeIcon8,
        title: "FireEye Mandiant",
        titleColor: "#b2282d",
        desc: "세계적으로 유명한 사고 대응 및 평가 , 개선 및 혁신 컨설팅 서비스로 , 조직의 중요 자산을 보호합니다 . Mandiant 는 공격자의 행동 , 독보적인\n" +
          "위협 인텔리전스 , 특별히 설계된 기술에 대한 깊이 있는 이해를 통해 비즈니스 위험을 최소화해 줍니다 .",
      },
    ];
    let list = data.map((value,index,array) => {
      let hide = value.hide;
      if(!hide) return (
        <DivFlexboxRow>
          <FireEyeIcon src={value.icon}/>
          <DivFlexboxColumn>
            <DivIndent20>
              <span style={{color:value.titleColor, fontSize:'24px', fontWeight:'bold'}}>{value.title}</span>
            </DivIndent20>
            <DivIndent20>
              <span>{value.desc}</span>
            </DivIndent20>
          </DivFlexboxColumn>
        </DivFlexboxRow>
      );

    });

    return (
      <div className="DetailsSecuritySolution">

        <Section className="section">
          <ContainerFluid className="container-fluid">

            <SubSection className="Intro">
              <p className="header-text-300" css={CssHeaderText300}>FireEye 는 자동화 분야에서 세계 최고 수준의 기술을 바탕으로 업계에서 인정받는 서비스, 국가 수준의 위협 인텔리전스 등 독보적인 일선 전문가들의 역량을 통합하여 사이버 공격으로 인한 영향과 결과로부터 고객을 철저하게 보호 합니다.</p>
              <p className="header-text-300" css={CssHeaderText300}>FireEye 는 Helix 라는 통합 보안 운영 플랫폼의 형태를 통해 고객의 보안 자산에서 수집한 데이터를 통합하고 분석하여 고객이 정말 중요한 위협에 대처할 수 있도록 실질적인 정보를 제공합니다.</p>
              <DivFlexboxNoWrap className="DivFlexboxNoWrap">
                <DivFlexItemNoWrap><ImgFlexItemNoWrap src={DetailsSecuritySolutionFireEyeImg}/></DivFlexItemNoWrap>
              </DivFlexboxNoWrap>
            </SubSection>

            <SubSection className="Features">
              <DivFlexboxColumn>
                {list}
              </DivFlexboxColumn>
            </SubSection>

          </ContainerFluid>
        </Section>

      </div>
    );
  }
}

export default DetailsSecuritySolutionFireEye;
